import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SpaceGroupDetailsContainer } from 'src/features/space-groups/containers/space-group-details';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/spaces/groups/$spaceGroupToken',
)({
  component: SpaceGroupDetailsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
